<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
export default {
  name: 'ScrollBoard',
  data () {
    return {
      config: {
        header: ['上报时间', '维护和修理记录', '状态'],
        data: [
          ['2023-12-29 18:30:10', '丽水雅苑 九栋 五单元 908 房屋漏水', '待处理' ],
          ['2023-12-28 18:30:10', '翠峰小区 六栋 八单元 506 电梯故障', '已处理' ],
          ['2023-12-23 18:30:10', '星光花园 二栋 十单元 1503 漏水天花板', '已处理' ],
          ['2023-12-21 18:30:10', '香榭雅筑 八栋 三单元 1101 窗户卡住', '已处理' ],
          ['2023-11-11 18:30:10', '时尚家园 五栋 六单元 1205 洗手间水龙头', '已处理' ],
          ['2023-11-10 18:30:10', '碧海湾 小六栋 十一单元 1802 电梯故障', '已处理' ],
          ['2023-11-03 18:30:10', '幸福花园 七栋 九单元 1003 煤气味道大', '已处理' ],
          ['2023-10-29 18:30:10', '雅居乐园 三栋 七单元 1104 门锁卡住', '已处理' ],
          ['2023-10-23 18:30:10', '美丽家园 六栋 四单元 802 窗户漏风', '已处理' ],
        ],
        index: true,
        columnWidth: [50, 150, 320, 80],
        align: ['center'],
        rowNum: 7,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 50%;
  box-sizing: border-box;
  margin-left: 20px;
  height: 100%;
  overflow: hidden;
}
</style>
